/* eslint-disable react-hooks/exhaustive-deps */
import { Plus, Trash2, Pencil, Copy } from 'lucide-react'
import { useEffect, useMemo, useState } from 'react'
import {
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  OverlayTrigger,
  Popover,
  Row,
  Table
} from 'react-bootstrap'
import { Loader } from 'react-bootstrap-typeahead'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import BreadCrumb from '../../components/Label/Breadcrumb'
import Loading from '../../components/atoms/Loading'
import ModalAddMaterialRequest from '../../components/modal/MaterialRequest/ModalAddMaterialRequest'
import ModalUpdateMaterialRequest from '../../components/modal/MaterialRequest/ModalUpdateMaterialRequest'
import api from '../../config/AxiosInstance'
import { convertDateWithoutTime } from '../../helpers/constants'
import toast, { Toaster } from 'react-hot-toast'

const cardStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelDetailStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#999',
  textTransform: 'uppercase',
  marginBottom: '0.25rem',
  letterSpacing: '0.5px'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const CreateMaterialRequest = () => {
  const { state } = useLocation()
  const { id } = useParams()
  const navigate = useNavigate()
  const [detailMaterialRequest, setDetailMaterialRequest] = useState({
    ...state?.item,
    warehouse_id:
      state?.item?.source_warehouse_id ||
      state?.item?.src_warehouse_id ||
      state?.item?.src_id ||
      null,
    old_warehouse_id:
      state?.item?.source_warehouse_id ||
      state?.item?.src_warehouse_id ||
      state?.item?.src_id ||
      null
  })
  const [isLoading, setIsLoading] = useState({
    page: false,
    table: false
  })
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const [pickupCommands, setPickupCommands] = useState({
    mr_code: id,
    series_number: null,
    items: []
  })
  const [seriesNumber, setSeriesNumber] = useState([])
  const [warehouses, setWarehouses] = useState([])
  const [pickupCommandId, setPickupCommandId] = useState(null)
  const [showModalAdd, setShowModalAdd] = useState(false)
  const [showModalUpdate, setShowModalUpdate] = useState(false)
  const fetchDetailMaterialRequest = async (id, overrideWarehouseId = null) => {
    try {
      setIsLoading((prevLoading) => ({
        ...prevLoading,
        page: true
      }))
      const response = await api.post(`/material-request/detail`, {
        mr_code: id,
        source_warehouse_id:
          overrideWarehouseId || detailMaterialRequest?.warehouse_id || null
      })
      const { data } = response
      if (data.success) {
        setDetailMaterialRequest((prev) => ({
          ...prev,
          ...data.data,
          warehouse_id:
            data.data.warehouse_id || overrideWarehouseId || prev.warehouse_id,
          old_warehouse_id:
            data.data.warehouse_id ||
            overrideWarehouseId ||
            prev.old_warehouse_id
        }))
        setPickupCommands((prevPickupCommand) => ({
          ...prevPickupCommand,
          items: data.data.pickup_commands.map((pickupCommandItem) => ({
            ...pickupCommandItem,
            id: Math.random().toString(36).substr(2, 9)
          }))
        }))
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setIsLoading((prevLoading) => ({
        ...prevLoading,
        page: false
      }))
    }
  }
  const fetchDetailWithChangeWarehouseMaterialRequest = async (id) => {
    try {
      setIsLoading((prevLoading) => ({
        ...prevLoading,
        table: true
      }))
      const response = await api.post(`/material-request/detail`, {
        mr_code: id,
        source_warehouse_id: detailMaterialRequest?.warehouse_id || null
      })
      const { data } = response
      if (data.success) {
        setDetailMaterialRequest((prevDetailMaterialRequest) => ({
          ...prevDetailMaterialRequest,
          warehouse_id: prevDetailMaterialRequest?.warehouse_id || '',
          old_warehouse_id: prevDetailMaterialRequest?.old_warehouse_id || '',
          items: data.data.items
        }))
        setPickupCommands((prevPickupCommand) => ({
          ...prevPickupCommand,
          items: data.data.pickup_commands.map((pickupCommandItem) => ({
            ...pickupCommandItem,
            id: Math.random().toString(36).substr(2, 9)
          }))
        }))
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setIsLoading((prevLoading) => ({
        ...prevLoading,
        table: false
      }))
    }
  }

  const fetchShowSeries = async () => {
    try {
      const res = await api.post(`material-request/show-series`, {
        mr_code: id
      })
      const { data } = res
      if (data.success) {
        setSeriesNumber(data.data)
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    }
  }
  const fetchWarehouses = async () => {
    try {
      const res = await api.get(`/material-request/source-warehouses`)
      const { data } = res
      if (data.success) {
        setWarehouses(data.data)
        return data.data
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    }
    return []
  }

  const handlePickupCommands = (value, valueInput) => {
    if (valueInput.isEdit) {
      setPickupCommands((prevPickupCommand) => {
        return {
          ...prevPickupCommand,
          items: prevPickupCommand.items.map((item) => {
            if (item.id === pickupCommandId) {
              return {
                ...value,
                id: pickupCommandId
              }
            }
            return item
          })
        }
      })
      setPickupCommandId(null)
    } else {
      const mrItemId =
        detailMaterialRequest?.items?.find(
          (item) => item.item_id === value.item_id
        )?.mr_item_id || null

      if (!mrItemId) {
        toast.error('Item not found!', {
          position: 'top-right',
          style: {
            fontSize: '14px',
            fontWeight: '600'
          }
        })
        return
      }
      value.mr_item_id = mrItemId
      setPickupCommands((prevPickupCommand) => {
        return {
          ...prevPickupCommand,
          items: [
            ...prevPickupCommand.items,
            {
              ...value,
              id: Math.random().toString(36).substr(2, 9)
            }
          ]
        }
      })
    }
  }

  const handleRemovePickupCommands = (itemPickupCommandId) => {
    Swal.fire({
      title: 'Delete Pickup Command?',
      icon: 'warning',
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setPickupCommands((prevPickupCommand) => {
          return {
            ...prevPickupCommand,
            items: prevPickupCommand.items.filter(
              (item) => item.id !== itemPickupCommandId
            )
          }
        })
      }
    })
  }

  const handleSubmit = () => {
    if (!pickupCommands.series_number) {
      Swal.fire({
        icon: 'error',
        text: 'Please select series number first',
        confirmButtonColor: '#f89d1d'
      })
      return
    }
    if (!pickupCommands.items.length) {
      Swal.fire({
        icon: 'error',
        text: 'Please add pickup command first',
        confirmButtonColor: '#f89d1d'
      })

      return
    }

    const totalQtyRequest = detailMaterialRequest?.items?.reduce(
      (acc, cur) => (acc += parseInt(cur.total_qty)),
      0
    )
    const totalQtyPickupCommand = pickupCommands?.items
      ?.flatMap((item) => item.slots)
      .reduce((total, slot) => total + parseInt(slot.total_qty, 10), 0)

    if (totalQtyPickupCommand < totalQtyRequest) {
      Swal.fire({
        title: 'Pick Up less than Request!',
        text: `Continue making TR?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#f89d1d',
        confirmButtonText: 'Create',
        cancelButtonColor: 'transparent',

        iconColor: '#828282',
        customClass: {
          title: 'swal-title-outbound',
          popup: 'swal-popup-outbound',
          actions: 'swal-remove-outbound'
        }
      }).then(async (result) => {
        if (result.isConfirmed) {
          handleCreate()
        } else {
          return false
        }
      })
      return
    }
    handleCreate()
  }

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text)
    toast.success('Copied to clipboard!', {
      position: 'top-right',
      style: {
        fontSize: '14px',
        fontWeight: '600'
      }
    })
  }

  const handleCreate = async () => {
    try {
      setLoadingSubmit(true)
      const res = await api.post('/material-request/create_tr', {
        ...pickupCommands,
        source_warehouse_id: detailMaterialRequest?.warehouse_id
      })
      const { data } = res
      if (data.success) {
        toast.success('TR created!', {
          position: 'top-right',
          style: {
            fontSize: '14px',
            fontWeight: '600'
          }
        })
        navigate('/material-request')
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setLoadingSubmit(false)
    }
  }
  const handleChangeWarehouse = (value) => {
    if (!value) {
      return toast.error('Please select warehouse', {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    }
    setDetailMaterialRequest((prev) => ({
      ...prev,
      warehouse_id: value || '',
      old_warehouse_id: prev.warehouse_id
    }))
  }
  const handleValidationSubmit = useMemo(() => {
    return (
      loadingSubmit ||
      !pickupCommands.series_number ||
      !pickupCommands.items.length ||
      !detailMaterialRequest?.warehouse_id
    )
  }, [loadingSubmit, pickupCommands, detailMaterialRequest?.warehouse_id])
  useEffect(() => {
    const init = async () => {
      const whData = await fetchWarehouses()
      let currentWarehouseId = detailMaterialRequest.warehouse_id
      if (!currentWarehouseId && state?.item?.src_name && whData) {
        const matched = whData.find(
          (w) =>
            w.warehouse_id === state.item.src_name ||
            state.item.src_name.includes(w.warehouse_id) ||
            w.warehouse_id.includes(state.item.src_name)
        )
        if (matched) {
          currentWarehouseId = matched.id
          setDetailMaterialRequest((prev) => ({
            ...prev,
            warehouse_id: matched.id,
            old_warehouse_id: matched.id
          }))
        }
      }
      fetchDetailMaterialRequest(id, currentWarehouseId)
      fetchShowSeries()
    }
    init()
  }, [id])
  useEffect(() => {
    if (
      detailMaterialRequest.warehouse_id !==
      detailMaterialRequest.old_warehouse_id
    ) {
      fetchDetailWithChangeWarehouseMaterialRequest(id)
    }
  }, [
    detailMaterialRequest.warehouse_id,
    detailMaterialRequest.old_warehouse_id
  ])
  if (isLoading.page) {
    return <Loading />
  }
  return (
    <>
      <Toaster />
      <Container fluid className="px-4 mb-5">
        <Row className="mb-2 mt-3">
          <Col>
            <BreadCrumb
              label={'Create TR'}
              link="/material-request/"
              back="Material Request"
              stateValue={state}
            />
          </Col>
        </Row>

        <Card style={cardStyle}>
          <Row className="gy-4">
            <Col md={6} lg={4}>
              <div style={labelDetailStyle}>
                SERIES <sup style={{ color: 'red' }}>*</sup>
              </div>
              <Form.Select
                aria-label="Default select example"
                name="series_number"
                id="series_number"
                className="border-0 bg-light px-3"
                style={{
                  fontSize: '0.9rem',
                  height: '40px',
                  borderRadius: '8px'
                }}
                onChange={(e) => {
                  setPickupCommands((prevPickupCommand) => ({
                    ...prevPickupCommand,
                    series_number: e.target.value
                  }))
                }}
              >
                <option value="">Select Series</option>
                {seriesNumber?.map((series, index) => (
                  <option key={series.name} value={series.name}>
                    {series.name}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={6} lg={4}>
              <div style={labelDetailStyle}>SOURCE WAREHOUSE</div>
              <Form.Select
                aria-label="source-warehouse-id"
                name="source_warehouse_id"
                id="source_warehouse_id"
                className="border-0 bg-light px-3"
                style={{
                  fontSize: '0.9rem',
                  height: '40px',
                  borderRadius: '8px'
                }}
                onChange={(e) => handleChangeWarehouse(e.target.value)}
                value={detailMaterialRequest.warehouse_id || ''}
              >
                <option value="">Select Source</option>
                {warehouses?.map((warehouse, index) => (
                  <option key={warehouse.id} value={warehouse.id}>
                    {warehouse.warehouse_id}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={6} lg={4}>
              <div style={labelDetailStyle}>TARGET WAREHOUSE</div>
              <Form.Control
                disabled
                className="border-0 bg-light px-3"
                style={{
                  fontSize: '0.9rem',
                  height: '40px',
                  borderRadius: '8px'
                }}
                placeholder={detailMaterialRequest?.target_name ?? '-'}
              />
            </Col>
            <Col md={6} lg={4}>
              <div style={labelDetailStyle}>ERP DOC NO.</div>
              <Form.Control
                disabled
                placeholder={''}
                className="border-0 bg-light px-3"
                style={{
                  fontSize: '0.9rem',
                  height: '40px',
                  borderRadius: '8px'
                }}
              />
            </Col>
            <Col md={6} lg={4}>
              <div style={labelDetailStyle}>DELIVERY DATE</div>
              <Form.Control
                disabled
                className="border-0 bg-light px-3"
                style={{
                  fontSize: '0.9rem',
                  height: '40px',
                  borderRadius: '8px'
                }}
                placeholder={
                  detailMaterialRequest?.delivery_date
                    ? convertDateWithoutTime(
                        detailMaterialRequest?.delivery_date
                      )
                    : '-'
                }
              />
            </Col>
            <Col md={6} lg={4}>
              <div style={labelDetailStyle}>MR CODE</div>
              <InputGroup>
                <Form.Control
                  disabled
                  placeholder={detailMaterialRequest?.code}
                  className="border-0 bg-light px-3"
                  style={{
                    fontSize: '0.9rem',
                    height: '40px',
                    borderTopLeftRadius: '8px',
                    borderBottomLeftRadius: '8px'
                  }}
                />
                <InputGroup.Text
                  className="border-0 bg-light px-3 cursor-pointer"
                  style={{
                    height: '40px',
                    borderTopRightRadius: '8px',
                    borderBottomRightRadius: '8px',
                    cursor: 'pointer'
                  }}
                  onClick={() => handleCopy(detailMaterialRequest?.code)}
                >
                  <Copy size={16} className="text-muted" />
                </InputGroup.Text>
              </InputGroup>
            </Col>
          </Row>
        </Card>

        <Row className="mb-4">
          <Col>
            <h5 className="text-secondary fw-semibold mb-3">Request List</h5>
            <Table
              hover
              responsive
              className="shadow-sm bg-white"
              style={{
                fontSize: '0.9rem',
                borderRadius: '12px',
                overflow: 'hidden'
              }}
            >
              <thead style={{ backgroundColor: '#f8f9fa' }}>
                <tr>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    #
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Item
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Item Alias
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Item Code
                  </th>
                  <th
                    className="p-2 align-middle text-end"
                    style={tableHeaderStyle}
                  >
                    Qty
                  </th>
                </tr>
              </thead>
              <tbody>
                {isLoading.table && (
                  <tr>
                    <td colSpan={5} className="text-center p-5">
                      <Loader />
                    </td>
                  </tr>
                )}
                {!isLoading.table && !detailMaterialRequest?.items?.length && (
                  <tr key={1}>
                    <td
                      colSpan={5}
                      className="text-center p-4 fw-bold text-muted"
                    >
                      No Data
                    </td>
                  </tr>
                )}
                {!isLoading.table &&
                  detailMaterialRequest?.items?.length > 0 &&
                  detailMaterialRequest?.items.map((item, index) => (
                    <tr
                      key={item.id}
                      style={{ borderBottom: '1px solid #f0f0f0' }}
                    >
                      <td className="p-2 align-middle text-center text-muted">
                        {index + 1}
                      </td>
                      <td className="p-2 align-middle fw-semibold text-primary">
                        {item.item_name}
                      </td>
                      <td className="p-2 align-middle">
                        {item.item_alias ?? '-'}
                      </td>
                      <td className="p-2 align-middle">{item.item_code}</td>
                      <td className="p-2 align-middle text-end fw-bold text-dark">
                        {item.total_qty} {item.uom_qty}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col className="d-flex justify-content-between align-items-center">
            <h5 className="text-secondary fw-semibold mb-0">Pickup Command</h5>
            <button
              className="btn btn-primary-orange rounded px-4"
              onClick={() => setShowModalAdd(true)}
              style={{ fontSize: '0.9rem' }}
            >
              <Plus size={18} className="me-2" />
              Add Pickup
            </button>
            <ModalAddMaterialRequest
              show={showModalAdd}
              onHide={() => setShowModalAdd(false)}
              items={detailMaterialRequest?.items}
              warehouseId={detailMaterialRequest?.warehouse_id}
              pickupCommands={pickupCommands}
              handlePickupCommands={handlePickupCommands}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Table
              hover
              responsive
              className="shadow-sm bg-white"
              style={{
                fontSize: '0.9rem',
                borderRadius: '12px',
                overflow: 'hidden'
              }}
            >
              <thead style={{ backgroundColor: '#f8f9fa' }}>
                <tr>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    #
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Item
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Item Alias
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Item Code
                  </th>
                  <th
                    className="p-2 align-middle text-end"
                    style={tableHeaderStyle}
                  >
                    Batch
                  </th>
                  <th
                    className="p-2 align-middle text-end"
                    style={tableHeaderStyle}
                  >
                    Expired
                  </th>
                  <th
                    className="p-2 align-middle text-end"
                    style={tableHeaderStyle}
                  >
                    Total Qty
                  </th>
                  <th
                    className="p-2 align-middle text-end"
                    style={tableHeaderStyle}
                  >
                    Total Pack
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Location
                  </th>
                  <th
                    className="p-2 align-middle text-end"
                    style={tableHeaderStyle}
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {isLoading.table && (
                  <tr>
                    <td colSpan={10} className="text-center p-5">
                      <Loader />
                    </td>
                  </tr>
                )}
                {!isLoading.table && pickupCommands?.items.length === 0 && (
                  <tr key={1}>
                    <td
                      colSpan={10}
                      className="text-center p-4 fw-bold text-muted"
                    >
                      No Data
                    </td>
                  </tr>
                )}
                {!isLoading.table &&
                  pickupCommands?.items?.length > 0 &&
                  pickupCommands?.items?.map((item, index) => (
                    <tr
                      key={item.id}
                      style={{ borderBottom: '1px solid #f0f0f0' }}
                    >
                      <td className="p-2 align-middle text-center text-muted">
                        {index + 1}
                      </td>
                      <td className="p-2 align-middle fw-semibold text-primary">
                        {item.item_name}
                      </td>
                      <td className="p-2 align-middle">
                        {item.item_alias ?? '-'}
                      </td>
                      <td className="p-2 align-middle">{item.item_code}</td>
                      <td className="p-2 align-middle text-end">
                        {item.batch}
                      </td>
                      <td className="p-2 align-middle text-end">
                        {item.exp_date
                          ? convertDateWithoutTime(item.exp_date)
                          : '-'}
                      </td>
                      <td className="p-2 align-middle text-end fw-bold text-dark">
                        {item?.total_qty}{' '}
                        {item?.slots && item?.slots[0]?.uom_qty}
                        {!item?.slots && ''}
                      </td>
                      <td className="p-2 align-middle text-end">
                        {item?.total_pack}
                      </td>
                      <td
                        className="p-2 align-middle"
                        style={{ maxWidth: '400px' }}
                      >
                        <OverlayTrigger
                          trigger={['hover', 'click']}
                          key={'bottom'}
                          placement={'bottom'}
                          overlay={
                            <Popover id={`popover-positioned-bottom`}>
                              <Popover.Body>
                                {item.slots &&
                                  item.slots
                                    .reduce((acc, cur) => {
                                      acc.push(cur.current_location)
                                      return acc
                                    }, [])
                                    .join(', ')}
                                {!item.slots && '-'}
                              </Popover.Body>
                            </Popover>
                          }
                        >
                          <p
                            className="text-truncate text-primary mb-0"
                            style={{ maxWidth: '80%', cursor: 'pointer' }}
                          >
                            {item.slots &&
                              item.slots
                                .reduce((acc, cur) => {
                                  acc.push(cur.current_location)
                                  return acc
                                }, [])
                                .join(', ')}
                            {!item.slots && '-'}
                          </p>
                        </OverlayTrigger>
                      </td>
                      <td className="p-2 align-middle text-end">
                        <div className="d-flex flex-row gap-2 justify-content-end">
                          <button
                            className="btn btn-light text-danger rounded p-2 shadow-sm"
                            onClick={() => handleRemovePickupCommands(item.id)}
                            style={{
                              cursor: 'pointer',
                              width: '35px',
                              height: '35px'
                            }}
                          >
                            <Trash2 size={16} />
                          </button>
                          <button
                            className="btn btn-light text-warning rounded p-2 shadow-sm"
                            onClick={() => {
                              setShowModalUpdate(true)
                              setPickupCommandId(item.id)
                            }}
                            style={{
                              cursor: 'pointer',
                              width: '35px',
                              height: '35px'
                            }}
                          >
                            <Pencil size={16} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row className="mb-5">
          <Col md={12}>
            <div className="d-flex flex-row justify-content-end">
              <button
                className={`btn ${
                  handleValidationSubmit
                    ? 'btn-secondary opacity-50'
                    : 'btn-primary-orange'
                } rounded px-5 py-2 fw-bold`}
                style={{
                  fontSize: '1rem',
                  boxShadow: '0 4px 6px rgba(248, 157, 29, 0.2)'
                }}
                onClick={() => handleSubmit()}
                disabled={handleValidationSubmit}
              >
                {loadingSubmit ? 'Loading...' : 'Submit TR'}
              </button>
            </div>
          </Col>
        </Row>
      </Container>

      <ModalUpdateMaterialRequest
        show={showModalUpdate}
        onHide={() => setShowModalUpdate(false)}
        items={detailMaterialRequest?.items}
        warehouseId={detailMaterialRequest?.warehouse_id}
        pickupCommands={pickupCommands}
        handlePickupCommands={handlePickupCommands}
        findPickupCommand={pickupCommands?.items?.find((pickupCommand) => {
          return pickupCommand.id === pickupCommandId
        })}
      />
      <Toaster />
    </>
  )
}

export default CreateMaterialRequest
